import { createGlobalStyle } from 'styled-components';
// Marcellus for headings (it has a single weight), Mulish for everything else.
// Both files are self-hosted and use font-display: swap.
import "@fontsource/marcellus/400"
import "@fontsource/mulish/300"
import "@fontsource/mulish/400"
import "@fontsource/mulish/600"
import "@fontsource/mulish/700"


const Typography = createGlobalStyle`  
    h1, h2, h3, h4, h5, h6 {
        font-family: 'Marcellus', serif;
        font-weight: 400;
        color: var(--blue);
    }
    h1 {
        font-size: 3rem;
        @media only screen and (max-width: 670px) {
          font-size: 2.5rem;
        }
    }
    h2 {
        font-size: 2rem;
        line-height: 3rem;
        margin: 1.5rem 0 .5rem 0;
        @media only screen and (max-width: 670px) {
          font-size: 1.5rem;
          line-height: 2.25rem;
        }
    }
    h3 {
        font-size: 1.5rem;
        @media only screen and (max-width: 670px) {
          font-size: 1.25rem;
        }
    }
    p {
        font-family: 'Mulish', sans-serif;
        line-height: 1.75rem;
        font-size: 1rem;
        margin-top: 0;
        color: #5f6b78;
    }
`

export default Typography;